import FavouritesButton from "@/components/Favourites/FavouritesButton";

import styles from "./wishlistToggle.module.scss";

type Props = {
  id: string;
  wishlistText: string;
  toggleText: (arg0: boolean) => void;
};

const UI = ({ id, toggleText, wishlistText }: Props) => {
  return (
    <FavouritesButton id={id} setInWishlist={toggleText}>
      <span className={styles.text}>{wishlistText}</span>
    </FavouritesButton>
  );
};

export default UI;
